import './ConfigAdmin.css'
import { useEffect, useState, forwardRef } from 'react';
import Cookies from 'universal-cookie';
import { Paper, FormControlLabel, Box, Checkbox, Divider, CardHeader, CardContent, Card, Grid, Button } from '@material-ui/core';
import TextField from '@mui/material/TextField';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import DateTimePicker from '@mui/lab/DateTimePicker';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import axios from 'axios';
import { useHistory } from 'react-router';
const Alert = forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
});
const ConfigAdmin = () => {
    const config = {
        readonly: false,
        buttons: ['bold', 'italic', 'underline', '|', 'ul', 'ol', '|', 'image', 'video', 'table', 'link', 'file', '|', 'font', 'fontsize', 'brush', 'eraser', '|', 'align', '|', 'undo', 'redo', '|', 'source', 'preview', '|'],
        placeholder: 'Inserta el contenido aquí',
        language: 'es',
        imageDefaultWidth: 300,
        useSplitMode: true,
        toolbarAdaptive: false,
    };
    const [openSuccess, setOpenSuccess] = useState(false);
    const [openError, setOpenError] = useState(false);
    const [error, setErrorMessage] = useState('');
    const [success, setSuccessMessage] = useState('');
    const [title, setTitle] = useState("");
    const [content, setContent] = useState("");
    const [valueBegin, setValueBegin] = useState(new Date());
    const [valueEnd, setValueEnd] = useState(new Date());
    const [showTime, setShowTime] = useState(false);
    const cookies = new Cookies();
    const userToken = cookies.get('tokenCTF');
    const [updateDate, setUpdateDate] = useState(false);
    const history = useHistory();
    const [contentInfo, setContentInfo] = useState("");
    const handleSetContext = value => {
        setContentInfo(value);
    };
    const handleClose = (event, reason) => {
        if (reason === 'clickaway') {
            return;
        }

        setOpenError(false);
        setOpenSuccess(false);
    };
    useEffect(() => {
        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/settingsAdmin/getDates`, {
            headers: { 'Authorization': userToken }
        }).then(res => {
            if (res.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                if (res.data.dateStart && res.data.dateEnd) {
                    setValueBegin(res.data.dateStart);
                    setValueEnd(res.data.dateEnd);
                    if (res.data.showTime === 'true') {
                        setShowTime(true);
                    }
                    else {
                        setShowTime(false);
                    }
                }
                else if (res.data.messageError) {
                    setErrorMessage(res.data.messageError);
                    setOpenError(true);
                }
            }
            setUpdateDate(false);

        })

    }, [updateDate])

    useEffect(() => {
        axios.get(`https://${process.env.REACT_APP_BASE_URL}/api/settingsAdmin/getCompetitionInfo`, {
            headers: { 'Authorization': userToken }
        }).then(res => {
            if (res.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                setContentInfo(res.data.competitionInfo);
                setTitle(res.data.title);
                setContent(res.data.content);
            }
        })
    }, [])
    const handleChangeDate = () => {
        axios.put(`https://${process.env.REACT_APP_BASE_URL}/api/settingsAdmin/updateTimeConfig`, { startDate: valueBegin, endDate: valueEnd, showTime: showTime }, {
            headers: { 'Authorization': userToken }
        })
            .then(res => {
                if (res.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                else {
                    if (res.data.messageSuccess) {
                        setSuccessMessage(res.data.messageSuccess)
                        setOpenSuccess(true)
                    }
                    else {
                        setErrorMessage(res.data.messageError)
                        setOpenError(true)
                    }
                }
            })
    };
    const handleShowTime = () => {
        setShowTime(!showTime);
    }
    const handleResetDate = () => {
        axios.put(`https://${process.env.REACT_APP_BASE_URL}/api/settingsAdmin/resetTimeConfig`, { startDate: valueBegin, endDate: valueEnd }, {
            headers: { 'Authorization': userToken }
        })
            .then(res => {
                if (res.data.noAuth) {
                    cookies.remove('tokenCTF', { path: '/' });
                    history.push('/login');
                }
                else {
                    if (res.data.messageSuccess) {
                        setSuccessMessage(res.data.messageSuccess)
                        setOpenSuccess(true)
                        setUpdateDate(true)
                    }
                    else {
                        setErrorMessage(res.data.messageError)
                        setOpenError(true)
                        setUpdateDate(false)
                    }
                }
            })
    };
    const handleChangeInfo = () => {
        axios.put(`https://${process.env.REACT_APP_BASE_URL}/api/settingsAdmin/adminHeaderInfo`, { title: title, content: content }, {
            headers: { 'Authorization': userToken }
        }).then(res => {
            if (res.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                if (res.data.messageSuccess) {
                    setSuccessMessage(res.data.messageSuccess);
                    setOpenSuccess(true);
                }
                else {
                    setErrorMessage(res.data.messageError);
                    setOpenError(true);
                }
            }
        })

    }
    const handleChangeCompetitionInfo = () => {
        axios.put(`https://${process.env.REACT_APP_BASE_URL}/api/settingsAdmin/setCompetitionInfo`, { competitionInfo: contentInfo }, {
            headers: { 'Authorization': userToken }
        }).then(res => {
            if (res.data.noAuth) {
                cookies.remove('tokenCTF', { path: '/' });
                history.push('/login');
            }
            else {
                if (res.data.messageSuccess) {
                    setSuccessMessage(res.data.messageSuccess);
                    setOpenSuccess(true);
                }
                else {
                    setErrorMessage(res.data.messageError);
                    setOpenError(true);
                }
            }
        })
    }
    return (
        <div className="configAdmin">
            <Paper className="pageContentTeam">
                <CardHeader
                    title="Tiempo - CTF"
                />
                <Divider />
                <br />
                <LocalizationProvider dateAdapter={AdapterDateFns} >
                    <DateTimePicker
                        renderInput={(props) => <TextField {...props} />}
                        label="Inicio del CTF"
                        months={['Enero', 'Febrero', 'Marzo', 'Abril', 'Mayo', 'Junio', 'Julio', 'Agosto', 'Septiembre', 'Octubre', 'Noviembre', 'Diciembre']}
                        value={valueBegin}
                        onChange={(newValue) => {
                            setValueBegin(newValue);
                        }}
                    />
                </LocalizationProvider>
                <br />
                <br />
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DateTimePicker
                        renderInput={(props) => <TextField {...props} />}
                        label="Fin del CTF"
                        value={valueEnd}
                        onChange={(newValue) => {
                            setValueEnd(newValue);
                        }}
                    />
                </LocalizationProvider>
                <br />
                <br />
                <div>
                    <FormControlLabel control={<Checkbox checked={showTime} value={showTime} onChange={(e) => { handleShowTime() }} />} label="Mostrar en pantalla principal" />
                </div>
                <Button variant="contained" color="primary" className="buttonMarginTop" onClick={() => { handleChangeDate() }}>
                    Guardar
                </Button>
                <Button variant="contained" color="secondary" className="buttonMarginTopMarginLeft" onClick={() => { handleResetDate() }}>
                    Reiniciar
                </Button>
            </Paper>
            <Card className="cardAdmin">
                <CardHeader
                    title="Información de encabezado - CTF"
                />
                <Divider />


                <CardContent>
                    <Grid
                        container
                        spacing={3}
                    >
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >

                            <TextField
                                fullWidth
                                label="Nombre de la competencia"
                                name="Titulo"
                                defaultValue={title ? title : ''}
                                value={title}
                                variant="outlined"
                                onChange={(e) => {
                                    setTitle(e.target.value)
                                }}

                            />
                        </Grid>
                        <Grid
                            item
                            md={6}
                            xs={12}
                        >
                            <TextField
                                fullWidth
                                label="Descripción"
                                name="Contenido"
                                defaultValue={content ? content : ''}
                                value={content}
                                variant="outlined"
                                onChange={(e) => {
                                    setContent(e.target.value)
                                }}
                            />
                        </Grid>


                    </Grid>
                </CardContent>
                <Divider />
                <Box
                    className="box"
                >
                    <Button className="buttonRight"
                        onClick={() => { handleChangeInfo() }}
                        variant="contained"
                        color="primary"
                    >
                        Guardar Cambios
                    </Button>
                </Box>

            </Card>
            <Card className="cardAdmin">
                <CardHeader
                    title="Información de la competencia - CTF"
                />
                <Divider />


                <CardContent>
                    <Grid item
                        md={12}
                        xs={12}>
                        <TextField
                            fullWidth
                            className="joditStylingAdmin"
                            id="outlined-multiline-static"
                            label="Reglas"
                            multiline
                            variant="outlined"
                            rows={20}
                            defaultValue={contentInfo}
                        /></Grid>
                </CardContent>
                <Divider />
                <Grid item
                >
                    <br />
                    <Button className="buttonRight"
                        onClick={(e) => { handleChangeCompetitionInfo() }}
                        variant="contained"
                        color="primary"
                    >
                        Guardar Cambios
                    </Button>
                </Grid>
            </Card>

            <Snackbar open={openError} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="error" className="alertWidthTop">
                    {error}
                </Alert>
            </Snackbar>
            <Snackbar open={openSuccess} autoHideDuration={3000} onClose={handleClose}>
                <Alert onClose={handleClose} severity="success" className="alertWidthTop">
                    {success}
                </Alert>
            </Snackbar>
        </div>
    );
};

export default ConfigAdmin;